import React from 'react';
import { DealPipelineView } from '@/components/views/DealPipelineView';

export const EndorsementsPage = () => {

	return <DealPipelineView pipelineId={process.env.REACT_APP_PIPELINE_ENDORSEMENTS} />;
};